import { Button, TableItem } from 'components/atoms';
import { Table } from 'components/organisms';
import { useFormikContext } from 'formik';
import { useTableColumnsVisibility } from 'hooks/useTableColumnsVisibility';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { PiNavigationArrow } from 'react-icons/pi';
import { ILabelReportDetailContractEarning } from 'services/label-report/types';
import { formatCurrency } from 'utils/global/currency.utils';
import { ILabelReportFormValues } from '../LabelReportForm';

const goToContract = (labelId: string, contractId: string) =>
  window.open(`/label/${labelId}/contract/${contractId}/form`, '_blank', 'noopener,noreferrer');

enum SORT_COLUMNS {
  contractTitle,
  amountEarned,
  amountEarnedLabel,
  actions,
}

interface TableNode {
  id: string;
  contractTitle: string;
  amountEarned: number;
  amountEarnedLabel: number;
}

const LabelReportContractEarnings: React.FC = () => {
  const { values } = useFormikContext<ILabelReportFormValues>();
  const { t } = useTranslation();
  const columnsVisibility = useTableColumnsVisibility(
    'LabelReportContractEarnings2',
    SORT_COLUMNS
  );
  const contractEarnings: ILabelReportDetailContractEarning[] =
    values?.contractEarnings ?? [];

  const tableData: TableNode[] = contractEarnings.map(row => ({
    id: row.contractId,
    contractTitle: row.contractTitle,
    amountEarned: row.amountEarned,
    amountEarnedLabel: row.amountEarnedLabel,
  }));

  return (
    <Table
      id={columnsVisibility.tableId}
      data={{ nodes: tableData }}
      columns={[
        {
          label: t('input.label.contractTitle'),
          renderCell: (item: TableNode) => (
            <TableItem>
              <TableItem.Text text={item.contractTitle} />
            </TableItem>
          ),
          resize: true,
          hide: columnsVisibility.hide(SORT_COLUMNS.contractTitle),
        },
        {
          label: t('input.label.amountEarned'),
          renderCell: (item: TableNode) => (
            <TableItem>
              <TableItem.Currency text={formatCurrency(item.amountEarned)} />
            </TableItem>
          ),
          resize: true,
          hide: columnsVisibility.hide(SORT_COLUMNS.amountEarned),
        },
        {
          label: t('input.label.amountEarnedLabel'),
          renderCell: (item: TableNode) => (
            <TableItem>
              <TableItem.Currency text={formatCurrency(item.amountEarnedLabel)} />
            </TableItem>
          ),
          resize: true,
          hide: columnsVisibility.hide(SORT_COLUMNS.amountEarnedLabel),
        },
        {
          label: '',
          renderCell: (item: TableNode) => (
            <TableItem justifyPosition='end'>
              <Button
                isClear
                onlyIcon
                onClick={() =>
                  goToContract(values?.labelId ?? '', item.id)
                }>
                                <Button.Description description={t('button.open')} />

                                <Button.Icon
                  icon={
                    <PiNavigationArrow transform='scale(-1,1)' />
                  }
                />
              </Button>
            </TableItem>
          ),
          resize: true,
          hide: columnsVisibility.hide(SORT_COLUMNS.actions),
        },
      ]}
    />
  );
};

export default LabelReportContractEarnings;
